module.exports = __webpack_public_path__ + "img/robot-banner.9c9bcb74.png";